import { Box, Typography, Autocomplete, TextField } from "@mui/material";
import { ColorsConstants } from "../../../../cssUtils/constants";
import { formatTitle } from "../utils";

export const EnumField = ({ label, value, schema, onChange }) => {
  const options = schema.enum || [];

  const isNumber = schema.type === "number";

  return (
    <Box>
      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
        {label || schema.description}
      </Typography>

      <Box>
        <Autocomplete
          options={options}
          value={options.find((opt) => opt === value) ?? null}
          getOptionLabel={(option) => formatTitle(option)}
          onChange={(event, newValue) => {
            if (newValue === null) {
              onChange(null);
              return;
            }

            onChange(isNumber ? Number(newValue) : newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={schema.description || label}
              size="small"
              fullWidth
            />
          )}
          sx={{
            "& .MuiOutlinedInput-root": {
              fontSize: 14,
            },
          }}
        />
      </Box>
    </Box>
  );
};
